const UserIcon = props => (
  <svg height={18} viewBox="0 0 17 18" width={17} {...props}>
    <title>UserAccount</title>
    <g fill="none" fillRule="evenodd" id="SYMBOLS" stroke="none" strokeWidth="1">
      <g fill="#283333" fillRule="nonzero" transform="translate(-1304.000000, -66.000000)">
        <g transform="translate(1304.000000, 66.000000)">
          <path
            d="M16,18 C16,13.581722 12.418278,10 8,10 C3.581722,10 0,13.581722 0,18 C0,18 16,18 16,18 Z"
            id="Circle"
          />
          <circle cx="8" cy="4" id="Circle" r="4" />
        </g>
      </g>
    </g>
  </svg>
);

export default UserIcon;
